import script from "./LabelSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./LabelSelector.vue?vue&type=script&setup=true&lang=js"

import "./LabelSelector.vue?vue&type=style&index=0&id=17ef44d4&lang=css"

const __exports__ = script;

export default __exports__